import { useQuery } from '@apollo/client';
import type { ProfileOccupationChoices_OccupationChoiceFilter as OccupationChoiceFilter } from '__generated__/graphql-types';

import ProfileOccupationChoices from 'bundles/employability-common/queries/ProfileOccupationChoices.graphql';
import type {
  ProfileOccupationChoicesQuery as ProfileOccupationChoicesQueryData,
  ProfileOccupationChoicesQueryVariables,
} from 'bundles/employability-common/queries/__generated__/ProfileOccupationChoices';

export const useProfileOccupationChoices = ({
  occupationChoiceFilter,
  queryOnServer = true,
}: {
  occupationChoiceFilter?: OccupationChoiceFilter;
  queryOnServer?: boolean;
}) => {
  const { data, loading, error } = useQuery<ProfileOccupationChoicesQueryData, ProfileOccupationChoicesQueryVariables>(
    ProfileOccupationChoices,
    {
      variables: { limit: 10000, occupationChoiceFilter },
      context: { clientName: 'gatewayGql' },
      ssr: queryOnServer,
    }
  );

  return {
    isProfileOccupationChoicesLoading: loading,
    error,
    occupations: data?.ProfileOccupationChoices?.queryOccupationChoices?.elements || [],
  };
};
